// src/App.js
import React from 'react';
import AppRouter from './router'; // ✅ Import your routing file

function App() {
  return <AppRouter />; // ✅ Use AppRouter instead of defining Routes again here
}

export default App;
